import {RoosterDetails, RoosterCard} from './Rooster';
import MicroIcon from '../shared/MicroIcon';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.CARD_NOTEBOOK);

export const card = RoosterCard;
export const details = RoosterDetails;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = RoosterCard;
